import { Component, Input, ElementRef, HostBinding, HostListener } from '@angular/core';

@Component({
  selector: '[tooltip]',
  templateUrl: './tooltip.directive.html',
  styleUrls: ['./tooltip.directive.less'],
  host: {
    '[style.position]': "'relative'",
    '(mouseenter)': 'onMouseEnter()',
    '(mouseleave)': 'onMouseLeave()'
  }
})
export class TooltipDirective {

  @Input('tooltip-text') text: string;
  @Input('tooltip-icon') icon: string;
  @Input('tooltip-position') position: string = 'left';

  private _hover: boolean = false;

  constructor(
  ) {
    console.info('INFO >> tooltip.directive.ts:10: constructor()');
  }

  onMouseEnter = () => {
    this._hover = true;
  }

  onMouseLeave = () => {
    this._hover = false;
  }

}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/common/tooltip/tooltip.directive.ts